import posthog, { type PostHogConfig } from 'posthog-js';
import { CLIENT_ENV } from '@/config/configuration';

const { NEXT_PUBLIC_ENV, NEXT_PUBLIC_POSTHOG_KEY, NEXT_PUBLIC_POSTHOG_HOST } = CLIENT_ENV();

if (['production', 'qa'].includes(NEXT_PUBLIC_ENV) && NEXT_PUBLIC_POSTHOG_KEY) {
  const config: Partial<PostHogConfig> = {
    api_host: NEXT_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
    disable_compression: false,
    disable_session_recording: true,
    capture_heatmaps: false,
    capture_exceptions: false,
    capture_performance: false,
    capture_pageview: false,
  };

  /**
   * Setting up PostHog on the client side
   *
   * Next.js 15.3 added support for instrumentation-client.js|ts which we can use to initialize PostHog.
   *
   * doc: https://posthog.com/tutorials/nextjs-analytics#setting-up-posthog-on-the-client-side
   */
  posthog.init(NEXT_PUBLIC_POSTHOG_KEY, config);
}
